import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format, parseISO } from "date-fns";
import { enUS } from "react-date-range/dist/locale";
import { getFinancialYearEndDate, getFinancialYearStartDate, getLastDateOfMonth } from "./utility";

export const DropdownDateRangePicker = ({
  initialStartDate,
  initialEndDate,
  minDate,
  maxDate,
  width,
  dateRange,
  setDateRange,
  formatDateRecoTab,
  tab,
  selection
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (ranges) => {
    setDateRange([ranges.selection]);
  };
//   useEffect(() => {
//       setDateRange([
//         {
//           startDate: initialStartDate ? getFinancialYearStartDate(initialStartDate) : initialStartDate,
//           endDate: initialEndDate ? getFinancialYearEndDate(initialEndDate) : initialEndDate,
//           key: "selection",
//         },
//       ]);
//     }

//   , [initialStartDate, initialEndDate]);
// const handleClear = () => {
//     setDateRange([
//       {
//         startDate: initialStartDate ? getFinancialYearStartDate(initialStartDate) : initialStartDate,
//           endDate: initialEndDate ? getFinancialYearEndDate(initialEndDate) : initialEndDate,
//           key: "selection",
//       },
//     ]);
//   };
const handleClear = () => {
  setDateRange([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
};

useEffect(() => {
  setDateRange([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
}, [initialStartDate, initialEndDate]);
  // const toggleDropdown = () => {
  //   setIsOpen(!isOpen);
  // };

  const toggleDropdown = () => {
    if(!selection){
      setIsOpen(false)
    }
   
  else{
    setIsOpen(!isOpen);
  }
  };

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };



  

  React.useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);


  const formatDate = (date) => {
    if (!date) return "";
    if (typeof date === "string") {
      try {
        return format(parseISO(date), "dd MMM");
      } catch {
        console.error("Invalid ISO date string:", date);
        return "";
      }
    }
    return format(date, "dd MMM");
  };


  const { startDate, endDate } = dateRange[0];
  // const { startDate, endDate } = dateRange[0] || {};

useEffect(() => {
  console.log('DropdownDateRangePicker Initial Start Date:', initialStartDate);
  console.log('DropdownDateRangePicker Initial End Date:', initialEndDate);
},[initialStartDate, initialEndDate]);
// useEffect(()=>{
//   console.log('DropdownDateRangePicker isOpen ::',isOpen)
// })
  return (
    <div
      style={{ position: "relative", width: width ? width : "203px" }}
      ref={dropdownRef}
    >
      <button
        onClick={toggleDropdown}
        style={{
          width: "100%",
          paddingTop: "5px",
          paddingBottom: "5px",
          borderRadius: "5px",
          border: "1px solid #ccc",
          backgroundColor: "#fff",
          textAlign: "center",
          cursor: "pointer",
        }}
      >
        
        {
        startDate && endDate && !tab ?  (
           `${formatDate(startDate)} - ${formatDate(endDate)}`         
        )
        :
        (
          // "Select Document Date Range"
          <div style={{ display: "flex" }}>
            <span
              style={{
                display: "flex",
                justifyContent: "flex-start",
                color: "#007bff",
              }}
            >
              Select Document Date Range
            </span>

          </div>
        )}
      </button>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            // top: "100%",
            left: 0,
            zIndex: 1000,
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "5px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            // padding: "10px",
            transform: "scale(0.8)",
            transformOrigin: "top left",
          }}
        >
          <DateRange
            editableDateInputs={true}
            onChange={handleSelect}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            showDateDisplay={false}
               minDate={new Date(2015, 0, 1)}
            maxDate={new Date(new Date().getFullYear() + 5, 11, 31)}
            // minDate={minDate ? getFinancialYearStartDate(minDate) : minDate}
            // maxDate={maxDate ? getFinancialYearEndDate(maxDate) : maxDate}
            rangeColors={["#6B46C1"]}
            locale={enUS}
            styles={{
              calendarWrapper: { transform: "scale(0.8)" },
            }}
          />
          <div
            style={{
              marginRight: "12px",
              marginBottom: "3px",
              textAlign: "right",
              cursor: "pointer",
              color: "#6B46C1",
              fontSize: "14px",
              fontWeight: "bold",
            }}
            onClick={handleClear}
          >
            Clear
          </div>
        </div>
      )}
    </div>
  );
};
